import {
  Button,
  Input,
  Form,
  notification,
  PageHeader,
  Col,
  Row,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import "../../Tools/customStyles.css";
import { useAuth } from "../../context/auth";
import LandlordDropdown from "../Dropdown/LandlordDropdown";
import IconLand from "../../static/icon/IconLand";

const PartySetting = ({ match: { params: { id } } }) => {
  const history = useHistory();
  const { accessToken } = useAuth();

  const [form] = Form.useForm();

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id === 'new') return;

    async function getParty() {
      const url = new URL('/api/party/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { party } = await res.json();
        form.setFieldsValue(party);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getParty();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    const url = new URL(id === 'new' ? '/api/party' : '/api/party/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: `/party`,
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconLand /> &nbsp;&nbsp;Group Setting
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row m-auto w-3/4 py-6"
          >
            <Row gutter={[32, 8]} style={{ marginTop: 15 }}>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Group Name (EN)"
                  name="nameEn"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Group Name (EN) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Group Name (EN) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Group Name (EN)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Group Name (TH)"
                  name="nameTh"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Group Name (TH) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Group Name (TH) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Group Name (TH)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Site Name"
                  name="landlordIds"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Site Name is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <LandlordDropdown
                    allowClear
                    allowSearch
                    mode="multiple"
                    setSelectedLandlords={(landlordIds) => form.setFieldsValue({ landlordIds })}
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="m-auto pt-6 flex justify-center space-x-4">
              <Button
                className="w-36"
                type="primary"
                ghost
                shape="round"
                htmlType="button"
                onClick={() => {
                  history.push({
                    pathname: `/party`,
                    searchValue: history.location.searchValue,
                    pageValue: history.location.pageValue,
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                className="w-36"
                key="save"
                type="primary"
                shape="round"
                htmlType="submit"
                disabled={disabled}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default PartySetting;
